import { useQuery } from "@tanstack/react-query";
import { fetchReleases } from "@/utils/dashboardFetch";

export const useReleasesQuery = () => {
    return useQuery({
        queryKey: ['releases'],
        queryFn: fetchReleases,
        staleTime: 1000 * 60 * 60, // 1 hour
    });
};
